export default "__VITE_ASSET__hEQ0apas__"